import { parseISO } from 'date-fns';

import { DateRangeValueType } from 'types';

export const rangeValueToDateObj = (value: DateRangeValueType) =>
  value === null ? null : parseISO(value);
